import React from "react";
import { Modal, Button } from 'react-bootstrap';

export default function CommonModal(props) {
    const cancelBtnClick = () => {
        props.setShowPopup(false);
        props.setConfirmatioData('no')
    }
    const saveBtnClick = () => {
        props.setShowPopup(false);
        props.setConfirmatioData('yes')

    }
    const styles = {
        height: {
            height: props.height
        }
    };
    return (
        <div>
            <div className="App p-4">
                <Modal style={styles.height} size="md" centered show={props.show}>
                    {props.closeBtn ?
                        <Modal.Header closeButton onClick={() => { props.closeBtn(false) }}>
                            <Modal.Title>{props.title}</Modal.Title>
                        </Modal.Header>
                        :
                        <Modal.Header>
                            <Modal.Title>{props.title}</Modal.Title>
                        </Modal.Header>
                    }
                    <Modal.Body style={styles.height}>
                        <div>
                            {props.body}
                        </div>
                    </Modal.Body>

                    {!props.noheader && <Modal.Footer>
                        <Button className="btn-confirm" onClick={saveBtnClick}>Yes</Button>
                        <Button className="btn-confirm" onClick={cancelBtnClick}>No</Button>
                    </Modal.Footer>
                    }
                </Modal>
            </div>
        </div>
    );
}